import { createSlice } from "@reduxjs/toolkit";
import { addQuery } from "helpers/utis";
import { api } from "service/api";
import { AuthApi } from "service/apiVariables";
import { Toast } from "service/toast";

export const loginSlice = createSlice({
  name: "auth",
  initialState: {
    isRememberMe: false,
    isLoading: true,
    userData: null,
    token: null,
    empCodes: [],
  },
  reducers: {
    saveRememberMe: (state, action) => {
      state.isRememberMe = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
      state.token = action.payload.token;
      state.isLoading = false;
    },
    logout: (state, action) => {
      state.userData = null;
      state.isRememberMe = false;
      state.empCodes = [];
    },
  },
});

export const getEmployeeCodes = () => () => {
  return new Promise((resolve, reject) => {
    api({ ...AuthApi.empCodesApi })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const verifyEmailVerificationCodeAct = (body) => async () => {
  const response = await api({
    ...AuthApi.verifyEmailVerificationCode,
    body,
  });

  Toast({
    type: "success",
    message: response?.message || "Email verified successfully",
  });

  return response?.data;
};

export const sendEmailVerificationCodeAct = (body) => async () => {
  const response = await api({
    ...AuthApi.sendEmailVerificationCode,
    body,
  });

  Toast({
    type: "success",
    message: response?.message || "OTP sent successfully",
  });

  return response?.data;
};

export const updateLoginEmailAct = (body) => async () => {
  const response = await api({
    ...AuthApi.updateLoginEmail,
    body,
  });

  Toast({
    type: "success",
    message: response?.message || "Email updated successfully",
  });

  return response?.data;
};
export const login = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    api({ ...AuthApi.loginApi, body })
      .then(({ data, message }) => {
        if (
          data?.role === 1 ||
          data?.role === 2 ||
          data?.role === 8 ||
          data?.role === 9
        ) {
          Toast({ type: "success", message: message });
          dispatch(saveUserData(data));
          resolve(data);
          sessionStorage.setItem("token", data?.token);
          sessionStorage.setItem("userDetails", JSON.stringify(data));
        } else {
          Toast({ type: "error", message: "Invalid User" });
        }
      })
      .catch((error) => {
        reject(error); // Pass the error object to catch block
      });
  });
};

export const resetPasswordAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...AuthApi.resetPasswordApi, body })
      .then(({ user, message }) => {
        Toast({ type: "success", message: message });
        resolve(user);
      })
      .catch((error) => {
        reject(error); // Pass the error object to catch block
      });
  });
};

export const forgetPasswordAct = (params) => {
  AuthApi.forgetPasswordApi.email = params;
  return new Promise((resolve, reject) => {
    api({ ...AuthApi.forgetPasswordApi })
      .then(({ data, message }) => {
        Toast({ type: "success", message: message });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getTokenValidAct = (query) => () => {
  addQuery(query, AuthApi.getValidToken);
  return new Promise((resolve, reject) => {
    api({ ...AuthApi.getValidToken })
      .then(({ data }) => {})
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const mailResetPasswordAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...AuthApi.mailResetPasswordApi, body })
      .then(({ user, message }) => {
        Toast({ type: "success", message: message });
        resolve(user);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const { saveRememberMe, saveUserData, logout } = loginSlice.actions;

export default loginSlice.reducer;
